import React from "react";
import precisionProspecting from "../../assets/images/B2B-Data/presition-prospecting.svg";
import alwaysUptoDate from "../../assets/images/B2B-Data/always-upto-date.svg";
import insightThatMatter from "../../assets/images/B2B-Data/insights-that-matters.svg";
import oneClickIntegration from "../../assets/images/B2B-Data/one-click-integration.svg";
import secureCompliant from "../../assets/images/B2B-Data/secure.svg";

const features = [
  {
    src: precisionProspecting,
    title: "Precision Prospecting",
    desc: "Filter and find your ideal leads based on location, industry, job title, revenue, and more."
  },
  {
    src: alwaysUptoDate,
    title: "Always Up-to-Date",
    desc: "Say goodbye to outdated contacts—our database is refreshed in real-time for maximum accuracy."
  },
  {
    src: insightThatMatter,
    title: "Insights That Matter",
    desc: "Access key data points like company size, market reach, and decision-making hierarchy to craft your perfect pitch."
  },
  {
    src: oneClickIntegration,
    title: "One-Click Integration",
    desc: "Effortlessly sync our database with your CRM and marketing tools to streamline workflows."
  },
  {
    src: secureCompliant,
    title: "Secure & Compliant",
    desc: "Built with privacy and security in mind, our database adheres to GDPR and other regulatory standards."
  }
];

const FeaturesList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-white tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">

        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Capabilities
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Features That Mean Business
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.03] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
            >
              {/* Ghost watermark icon in background */}
              <div className="tw-absolute tw-bottom-[-12px] tw-right-[-12px] tw-w-24 tw-h-24 tw-opacity-[0.05] tw-pointer-events-none">
                <img
                  src={item.src}
                  alt=""
                  aria-hidden="true"
                  className="tw-w-full tw-h-full tw-object-contain"
                />
              </div>

              {/* Icon Container */}
              <div
                className="tw-w-14 tw-h-14 tw-mb-6 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-rounded-2xl"
                style={{
                  backgroundColor: "#EEF2FF",
                  border: "1.5px solid #C7D2FE",
                }}
              >
                <img
                  src={item.src}
                  alt={item.title}
                  className="tw-w-7 tw-h-7 tw-object-contain"
                />
              </div>

              {/* Text */}
              <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                {item.title}
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default FeaturesList;
